import React from "react";
import TSTable from "../common/TSTable";
import { Layout, message, Modal, Popconfirm, Spin, theme, Tooltip, Dropdown } from 'antd';
import HeaderScreen from "../common/HeaderScreen";
import * as _ from "lodash";
import { Content } from "antd/es/layout/layout";
import {
  PlusOutlined,
  PrinterOutlined,
  FileOutlined,
  EditOutlined,
  FileDoneOutlined,
  ExclamationCircleOutlined,
  CheckCircleFilled,
  QuestionCircleFilled,
  RollbackOutlined,
  CheckCircleOutlined,
  FileTextOutlined,
  UploadOutlined,
  ContainerOutlined,
} from '@ant-design/icons';
import { GRAY_ICON_COLOR, PRIMARY_COLOR, PRINT_COLOR, SECONDARY_COLOR, WHITE_COLOR } from "../constants/color";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDatabase } from '@fortawesome/free-solid-svg-icons';
import { URL_REPORT, URL_SALE } from "../constants/urls";
import { useParams } from "react-router-dom";
import { DELETE, GET, POST } from "../frameworks/HttpClient";
import { dateToHumanString, formatComma, toFixed } from "../frameworks/Util";
import ColorButton from "../common/ColorButton";
import DeliveryOrderModal from "../components/sale-list/DeliveryOrderModal";
import LoadProductListModal from "../components/sale-list/LoadProductListModal";
import { DELIVERY_ACTION, PRODUCT_TYPE } from "../constants/string";
import ErrorMessages from "../common/ErrorMessages";
import ReportButton from "../components/common/ReportButton";
import CustomDeleteConfirmButton from "../common/CustomDeleteConfirmButton";

export default function DeliveryOrderScreen() {
  const params = useParams();
  const { token : { colorWarning, colorError, colorSuccess, colorPrimary }} = theme.useToken();
  const [ deliveryTarget, setDeliveryTarget] = React.useState(null);
  const [ saleOrderData, setSaleOrderData] = React.useState(null);
  const [ loadTarget, setLoadTarget] = React.useState(null);
  const [ errorMessages, setErrorMessages] = React.useState(null);
  const [ loading, setLoading] = React.useState(true);
  const [reportLoading, setReportLoading] = React.useState(false);
  const tableRef = React.useRef();

  const fetchSaleOrderData = async() => {
    setLoading(true)
    setErrorMessages(null);
    try {
      if(params.type === PRODUCT_TYPE.CONCENTRATE_LATEX){
        const response = await GET(`${URL_SALE.SALE_ORDER}${params.id}/`)
        setSaleOrderData(response.data)
      } else {
        const response = await GET(`${URL_SALE.SKIM_SALE_ORDER}${params.id}/`)
        setSaleOrderData(response.data)
      }
    } catch (error) {
      setErrorMessages(error.errorMessages)
    } finally{
      setLoading(false)
    }
  }

  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage()
    )
  }

  const handleDelete = async (id) => {
    setErrorMessages(null);
    try {
      if(params.type === PRODUCT_TYPE.CONCENTRATE_LATEX){
        await DELETE(`${URL_SALE.DELIVERY_ORDER}${id}/`);
        message.success("ลบรายการสำเร็จ");
        refreshData();
      } else {
        await DELETE(`${URL_SALE.SKIM_DELIVERY_ORDER}${id}/`);
        message.success("ลบรายการสำเร็จ");
        refreshData();
      }
    } catch (error) {
      setErrorMessages (error.errorMessages);
    }
  };

  const deliveryComplete = async (id) => {
    setErrorMessages(null);
    try {
      if(params.type === PRODUCT_TYPE.CONCENTRATE_LATEX){
        await POST(`${URL_SALE.DELIVERY_ORDER}${id}/${DELIVERY_ACTION.COMPLETE}/`);
        message.success("ส่งน้ำยางเสร็จสิ้น");
        refreshData();
      } else {
        await POST(`${URL_SALE.SKIM_DELIVERY_ORDER}${id}/${DELIVERY_ACTION.COMPLETE}/`);
        message.success("ส่งสินค้าสกิมเสร็จสิ้น");
        refreshData();
      }
    } catch (error) {
      setErrorMessages(error.errorMessages)
    }
  }

  const deliveryRevert = async (id) => {
    setErrorMessages(null);
    try {
      if(params.type === PRODUCT_TYPE.CONCENTRATE_LATEX){
        await POST(`${URL_SALE.DELIVERY_ORDER}${id}/${DELIVERY_ACTION.REVERT}/`);
        refreshData();
      } else {
        await POST(`${URL_SALE.SKIM_DELIVERY_ORDER}${id}/${DELIVERY_ACTION.REVERT}/`);
        refreshData();
      }
    } catch (error) {
      setErrorMessages(error.errorMessages)
    }
  }

  const confirm = (value) => {
    Modal.confirm({
      title: params.type === PRODUCT_TYPE.CONCENTRATE_LATEX ? `ส่งน้ำยางข้นเสร็จสิ้น` : `ส่งสินค้าสกิมเสร็จสิ้น`,
      icon: <ExclamationCircleOutlined style={{ color : PRIMARY_COLOR}} />,
      content: params.type === PRODUCT_TYPE.CONCENTRATE_LATEX ? 'การส่งน้ำยางข้นเสร็จสิ้นแล้วใช่หรือไม่ ?' : 'การส่งสกิมเสร็จสิ้นแล้วใช่หรือไม่ ?',
      okText: 'ใช่',
      cancelText: 'ปิด',
      maskClosable: true,
      okButtonProps: {style: { backgroundColor : PRIMARY_COLOR}},
      onOk:async() => {
          await deliveryComplete(value.id)
      },
      onConfirm: () => refreshData()
    });
  };

  const confirmRevert = (value) => {
    Modal.confirm({
      title: `ยืนยันย้อนกลับ`,
      icon: <ExclamationCircleOutlined style={{ color : PRIMARY_COLOR}} />,
      content: 'ต้องการย้อนกลับไปแก้ไขข้อมูลใช่หรือไม่ ?',
      okText: 'ยืนยัน',
      cancelText: 'ปิด',
      maskClosable: true,
      okButtonProps: {style: { backgroundColor : PRIMARY_COLOR}},
      onOk:async() => {
          await deliveryRevert(value.id)
      },
      onConfirm: () => refreshData()
    });
  };

  const columns = [
    {
      title : 'Action',
      dataIndex : '',
      key : 'action',
      render: (value, original) => (
        <div style={{ textAlign: 'center' }} onClick={(e) => e.stopPropagation()}>
          <Tooltip triger='hover' title={"พิมพ์ใบส่งสินค้า"}>
            <Dropdown
              trigger='click'
              placement='top'
              arrow={true}
              menu={{items: [
                { 
                  key: 'order', 
                  label: (
                    <ReportButton
                      url={`${URL_REPORT.LOAD_ORDER}${original.id}`}
                      icon={<UploadOutlined/>}
                      block type='text'
                      sentLoading={setReportLoading}>
                      ใบสั่งจ่าย
                    </ReportButton>
                  ) 
                },
                { 
                  key: 'temp', 
                  label: (
                    <ReportButton
                      url={`${URL_REPORT.DELIVERY_BILL}${original.id}`}
                      icon={<FileTextOutlined/>}
                      block type='text'
                      sentLoading={setReportLoading}>
                      ใบส่งสินค้าชั่วคราว(A4)
                    </ReportButton>
                  ) 
                },
                { 
                  key: 'temp_form', 
                  label: (
                    <ReportButton
                      url={`${URL_REPORT.DELIVERY_BILL_PAPER_FORM}${original.id}`}
                      icon={<FileOutlined />}
                      block type='text'
                      sentLoading={setReportLoading}>
                      ใบส่งสินค้าชั่วคราว(Form)
                    </ReportButton>
                  ) 
                },
                { 
                  key: 'final', 
                  label: (
                    <ReportButton
                      url={`${URL_REPORT.FINALIZED_DELIVERY_ORDER_BILL}${original.id}`}
                      icon={<CheckCircleOutlined/>}
                      block type='text'
                      sentLoading={setReportLoading}>
                      Delivery Order
                    </ReportButton>
                  ) 
                },
                { 
                  key: 'example', 
                  label: (                    
                    <ReportButton url={`${URL_REPORT.LAB_REQUEST_ORDER}${original.id}/`}
                      icon={<ContainerOutlined />}
                      block type='text'
                      sentLoading={setReportLoading}>
                        ฉลากตัวอย่างน้ำยางข้นจากการบรรจุ
                    </ReportButton>
                  )
                },
              ]}}
            >
              <ColorButton 
                override={PRINT_COLOR}
                style={{ margin: 5 }}
                type='primary'
                icon={<PrinterOutlined />}
                loading={reportLoading}
              />
            </Dropdown>
          </Tooltip>

          {!original.is_complete && <Tooltip triger='hover' Tooltip title={"โหลดสินค้า"}>
            <ColorButton 
              override={colorSuccess}
              style={{ margin: 5 }}
              type='primary'
              icon={<FontAwesomeIcon icon={faDatabase} />}
              onClick={() => setLoadTarget(original)} 
            />
          </Tooltip>}

          {(!original.has_loaded_transaction) && 
            <CustomDeleteConfirmButton
              title={`ยืนยันลบใบส่งหรือไม่`}
              content={`คุณต้องการลบใบส่ง${params.type === PRODUCT_TYPE.CONCENTRATE_LATEX ? 'น้ำยางข้น' : 'สกิม'}นี้ใช่หรือไม่ ?`}
              onOk={ async() => {
                await handleDelete(original.id)
                refreshData();
              }}
              onConfirm={() => refreshData()}
            />
          }

          {!original.is_complete && <Tooltip triger='hover' title={"แก้ไขข้อมูล"}>
            <ColorButton 
              override={colorWarning}
              style={{ margin: 5 }}
              type='primary'
              icon={<EditOutlined />}
              onClick={() =>  setDeliveryTarget(original)} 
            />
          </Tooltip>}

          {(original.net_weight ? original.net_weight != 0 : original.net_amount != 0) && original.is_complete == false &&  <Tooltip triger='hover' title={params.type === PRODUCT_TYPE.CONCENTRATE_LATEX ? "ส่งน้ำยางข้น" : 'ส่งสกิม'}>
            <ColorButton 
              override={colorPrimary}
              style={{ margin: 5 }}
              type='primary'
              icon={<FileDoneOutlined />}
              onClick={() => confirm(original, original.is_complete)} 
            />
          </Tooltip>}

          {original.is_complete == true &&  <Tooltip triger='hover' title={"ย้อนกลับ"}>
            <ColorButton 
              override={colorPrimary}
              style={{ margin: 5 }}
              type='primary'
              icon={<RollbackOutlined />}
              onClick={() => confirmRevert(original)} 
            />
          </Tooltip>}

        </div>
      )
    },
    {
      title : 'สถานะส่ง',
      dataIndex : 'is_complete',
      key : 'is_complete',
      render : (value) => 
      <center>
        {value ? <CheckCircleFilled style={{ color : colorSuccess}}/> : <QuestionCircleFilled style={{ color : GRAY_ICON_COLOR}}/>}
      </center>
    },
    {
      title : 'วันที่ส่ง',
      dataIndex : 'date',
      key : 'date',
      render : (value) => dateToHumanString(value)
    },
    {
      title : 'SERIAL ID',
      dataIndex : 'serial_id',
      key : 'serial_id'
    },
    {
      title : 'SERIAL NO',
      dataIndex : 'serial_no',
      key : 'serial_no'
    },
    {
      title : 'ชื่อลูกค้า',
      dataIndex : 'buyer_name',
      key : 'buyer_name',
    },
    {
      title : 'ปริมาณสุทธิ(ก้อน)',
      dataIndex : 'net_amount', 
      key : 'net_amount',
      align : 'center',
      render: (value) => formatComma(value),
      hidden : params.type === PRODUCT_TYPE.CONCENTRATE_LATEX ? true : false
    },
    {
      title : params.type === PRODUCT_TYPE.CONCENTRATE_LATEX ? 'ปริมาณสุทธิ(kg)' : 'น้ำหนักประมาณ(kg)',
      dataIndex : 'net_weight',
      key : 'net_weight',
      align : 'center',
      render: (value) => formatComma(value),
    },
    {
      title : 'ผู้บันทึก',
      dataIndex : 'created_by_name',
      key : 'created_by_name',
    },
  ]

  React.useEffect(() => {
    fetchSaleOrderData();
  },[])

  React.useEffect(() => {
    if(saleOrderData){
      refreshData();
    }
  },[saleOrderData])

	return(
    <Layout>
      <Spin spinning={loading}>
      <HeaderScreen title={`${params.type === PRODUCT_TYPE.CONCENTRATE_LATEX ? `รายการส่งน้ำยางข้น` : `รายการส่งสินค้าสกิม`} - ${_.get(saleOrderData, 'order_no', '')}`} style={{ backgroundColor : SECONDARY_COLOR, color : WHITE_COLOR, fontSize : 18, fontWeight: 'bolder' }}/>
      <ErrorMessages message={errorMessages} style ={{marginTop : 16}}/>
      <Content
        style={{
          margin: 24,
          minHeight: 280,
          padding: "0px 24px",
      }}>
        {saleOrderData && <ColorButton 
          type='primary'
          override={colorSuccess}
          icon={<PlusOutlined style={{ fontSize : 14 }}/>}
          onClick={()=> setDeliveryTarget('add')} 
          style={{ float : 'right', marginBottom : 10}}
        >
          เพิ่มรายการส่ง
          </ColorButton>}
          
        {saleOrderData && <TSTable
          ref={tableRef}
          columns={columns}
          url={params.type === PRODUCT_TYPE.CONCENTRATE_LATEX ? URL_SALE.DELIVERY_ORDER : params.type === PRODUCT_TYPE.SKIM ? URL_SALE.SKIM_DELIVERY_ORDER : null}
          size={"small"}
          params={{sale_order : _.get(saleOrderData, 'id', '')}}
        />}
      </Content>

      <DeliveryOrderModal
        open={deliveryTarget ? true : false}
        onClose={() => {
          setDeliveryTarget(null)
        }}
        onUpdate={() => {
          setDeliveryTarget(null)
          refreshData();
        }}
        target={deliveryTarget}
        saleOrder={saleOrderData}
      />

      <LoadProductListModal
        open={loadTarget ? true : false}
        onClose={() => {
          setLoadTarget(null)
        }}
        onUpdate={() => {
          setLoadTarget(null)
          refreshData()
        }}
        target={loadTarget}
        saleOrder={saleOrderData}
      />
    </Spin>
    </Layout>
)
}